import { Helmet } from "react-helmet-async";

const DEFAULT_OG_IMAGE =
  "https://travel.rethinkways.com/wp-content/uploads/2025/12/travel-rethink-ways-feature-img.jpg";

function SEO({
  title,
  description,
  canonical,
  image = DEFAULT_OG_IMAGE,
  imageAlt = "Travel Rethink Ways feature image",
  siteName = "Travel Rethink Ways",
  locale = "en_US",
  robots = "index,follow,max-image-preview:large",
}) {
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name="description" content={description} />
        <meta name="robots" content={robots} />
        <link rel="canonical" href={canonical} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={siteName} />
        <meta property="og:locale" content={locale} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:image" content={image} />
        <meta property="og:image:alt" content={imageAlt} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:image:alt" content={imageAlt} />
      </Helmet>
    </>
  );
}

export default SEO;
